import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

import { useAppUtilityContext } from "../../Contexts/AppUtilityContext";

import { isActiveModule } from "../../Utils/helpers";
import { getNavItems } from "../../Utils/helpers";

export default function NavBar() {
  const { pathname } = useLocation();

  const {
    appUtilityProps: { hideDealsRoutes },
  } = useAppUtilityContext();

  const navItems = useMemo(() => getNavItems({ hideDealsRoutes }), [hideDealsRoutes]);

  return (
    <div className="app-utility-navbar">
      {navItems.map(({ Icon, navItemName, navRoute }, idx) => (
        <Link key={idx} className={`navbar-item${isActiveModule(navRoute, pathname) ? " active" : ""}`} to={navRoute}>
          <Icon className="nav-icon" />
          {navItemName}
        </Link>
      ))}
    </div>
  );
}
